module.exports = __webpack_public_path__ + "static/media/googlemaps.e6c812c1.svg";